export const RESET_UPDATE_COMPANY_ERROR = 'RESET_UPDATE_COMPANY_ERROR';
export const UPDATE_COMPANY_DETAILS = 'UPDATE_COMPANY_DETAILS';
export const UPDATE_COMPANY_FORM_ERROR = 'UPDATE_COMPANY_FORM_ERROR';
export const UPDATE_COMPANY_CLEAR_FORM_ERROR = 'UPDATE_COMPANY_CLEAR_FORM_ERROR';

export const UPDATE_COMPANY_APPLICATION = 'UPDATE_COMPANY_APPLICATION';
export const UPDATE_COMPANY_APPLICATION_SUCCESS = 'UPDATE_COMPANY_APPLICATION_SUCCESS';

export const CHANGE_UPDATE_COMPANY_STEP = 'CHANGE_UPDATE_COMPANY_STEP';
export const INITIATE_UPDATE_COMPANY = 'INITIATE_UPDATE_COMPANY';
export const INITIATE_START_UPDATE_COMPANY = 'INITIATE_START_UPDATE_COMPANY';
export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';

export const CLEAR_UPDATE_COMPANY_APPLICATION_ERROR = 'CLEAR_UPDATE_COMPANY_APPLICATION_ERROR';

export const FETCH_LEGAL_FORMS = 'FETCH_LEGAL_FORMS';
export const FETCH_LEGAL_FORMS_SUCCESS = 'FETCH_LEGAL_FORMS_SUCCESS';

export const UPDATE_COMPANY_CANCEL_APPLICATION = 'UPDATE_COMPANY_CANCEL_APPLICATION';
export const UPDATE_COMPANY_CANCEL_APPLICATION_SUCCESS = 'UPDATE_COMPANY_CANCEL_APPLICATION_SUCCESS';
export const UPDATE_COMPANY_CANCEL_APPLICATION_ERROR = 'UPDATE_COMPANY_CANCEL_APPLICATION_ERROR';

export const UPDATE_COMPANY_DATA = 'UPDATE_COMPANY_DATA';
export const UPDATE_CITY_DATA = 'UPDATE_CITY_DATA';

export const ADD_COMPANY = 'ADD_COMPANY';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';

export const UPLOAD_COMPANY_DOCUMENT = 'UPLOAD_COMPANY_DOCUMENT';
export const UPLOAD_COMPANY_DOCUMENT_SUCCESS = 'UPLOAD_COMPANY_DOCUMENT_SUCCESS';

export const DELETE_COMPANY_DOCUMENT = 'DELETE_COMPANY_DOCUMENT';

export const DOWNLOAD_COMPANY_DOCUMENT = 'DOWNLOAD_COMPANY_DOCUMENT';
export const DOWNLOAD_COMPANY_DOCUMENT_SUCCESS = 'DOWNLOAD_COMPANY_DOCUMENT_SUCCESS';

export const CHECKOUT_UPDATE_COMPANY = 'CHECKOUT_UPDATE_COMPANY';
export const CHECKOUT_UPDATE_COMPANY_SUCCESS = 'CHECKOUT_UPDATE_COMPANY_SUCCESS';
export const CHECKOUT_UPDATE_COMPANY_ERROR = 'CHECKOUT_UPDATE_COMPANY_ERROR';

export const UPDATE_COMPANY_TERMINATION_START = 'UPDATE_COMPANY_TERMINATION_START';
export const UPDATE_COMPANY_TERMINATION_SUCCESS = 'UPDATE_COMPANY_TERMINATION_SUCCESS';

export const FETCH_UPDATE_PROFILE_START = 'FETCH_UPDATE_PROFILE_START';
export const FETCH_UPDATE_PROFILE_SUCCESS = 'FETCH_UPDATE_PROFILE_SUCCESS';

export const SAVE_LATEST_PROFILE_START = 'SAVE_LATEST_PROFILE_START';
export const SAVE_LATEST_PROFILE_SUCCESS = 'SAVE_LATEST_PROFILE_SUCCESS';
